import React from 'react'
import { createPortal } from 'react-dom'
import Button from '../Button'

export default function MFALearningModal({ isOpen, onClose }) {
  if (!isOpen) return null

  return createPortal(
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
      <div className='bg-white rounded-2xl shadow-xl max-w-lg w-full p-6 relative animate-fadeIn overflow-y-auto max-h-[90vh]'>
        {/* Close Button */}
        <button
          onClick={onClose}
          className='absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl cursor-pointer'>
          ✕
        </button>

        <h2 className='!text-[24px] font-bold mb-4 text-center'>
          How to Set Up MFA
        </h2>

        <div className='space-y-5 text-gray-700 leading-relaxed'>
          <div>
            <p>
              <strong>Multi-Factor Authentication (MFA)</strong> helps protect
              your account by requiring both your password and a code generated
              on your phone.
            </p>
          </div>

          <div>
            <h3 className='!font-semibold mb-1'>Step 1: Install an App</h3>
            <p>
              Download an authenticator app such as{' '}
              <span className='font-medium'>Google Authenticator</span>,{' '}
              <span className='font-medium'>Duo</span>, or{' '}
              <span className='font-medium'>Microsoft Authenticator</span> on
              your phone.
            </p>
          </div>

          <div>
            <h3 className='!font-semibold mb-1'>Step 2: Scan or Enter Key</h3>
            <p>
              On the setup page, you’ll see a{' '}
              <span className='font-medium'>QR code</span> and a{' '}
              <span className='font-medium'>secret key</span>. Open your
              authenticator app and either scan the QR code or enter the secret
              key manually.
            </p>
          </div>

          <div>
            <h3 className='!font-semibold mb-1'>Step 3: Verify Code</h3>
            <p>
              Your app will now generate{' '}
              <span className='font-medium'>6-digit codes</span>. Enter the
              current code in the setup form to confirm your MFA.
            </p>
          </div>

          <div>
            <h3 className='!font-semibold mb-1'>Step 4: Save Recovery Codes</h3>
            <p>
              After verification, you’ll be given{' '}
              <span className='font-medium'>recovery codes</span>. Store them
              safely — they can be used if you lose access to your phone.
            </p>
          </div>
        </div>

        <div className='mt-6 text-center'>
          <Button onClick={onClose} className='login-button'>
            Got it, Close
          </Button>
        </div>
      </div>
    </div>,
    document.body
  )
}
